import React from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "../Theme";

import colors from "../../styles/settings/colors.scss";
import styles from "./Icon.scss";

export const Icon = ({
  size,
  color,
  fill,
  icon,
  style,
  customClass,
  wrapperProps,
  ...others
}) => {
  const context = React.useContext(ThemeContext);
  const SvgIcon = icon;

  let classNames = styles.icon;
  if (context) {
    classNames += ` ${styles[context]}`;
  }
  const fillDefault = typeof SvgIcon.fill !== "undefined" ? SvgIcon.fill : true;
  if ((fill !== null && fill) || (fill === null && fillDefault)) {
    classNames += ` ${styles.fillPath}`;
  }
  if (size) {
    classNames += ` ${size}`;
  }
  if (customClass) {
    classNames += ` ${customClass}`;
  }

  return (
    <span className={styles.wrapper} aria-hidden="true" {...wrapperProps}>
      <SvgIcon
        className={classNames}
        style={{ color, ...style }}
        focusable="false"
        {...others}
      />
    </span>
  );
};

export const IconPropTypes = {
  icon: PropTypes.elementType.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  fill: PropTypes.bool,
  style: PropTypes.shape({}),
  wrapperProps: PropTypes.objectOf(PropTypes.any),
  customClass: PropTypes.string,
};

Icon.propTypes = IconPropTypes;

Icon.defaultProps = {
  size: null,
  color: null,
  fill: null,
  style: {},
  wrapperProps: null,
  customClass: null,
};

Icon.Size = {
  parent: styles.parentsize,
  xxsmall: styles.xxsmall,
  xsmall: styles.xsmall,
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
  xlarge: styles.xlarge,
  xxlarge: styles.xxlarge,
  xxxlarge: styles.xxxlarge,
};

Icon.Color = colors;

Icon.displayName = "Icon";

export default Icon;
